import { Navigate, useLocation } from "react-router-dom";
import { SideBar } from "./SideBar";
import DeviceIcon from "../../assets/images/vectors/SideBarIcons/DeviceIcon";
import DeviceLogIcon from "../../assets/images/vectors/SideBarIcons/DeviceLogIcon";
import OrderIcon from "../../assets/images/vectors/SideBarIcons/OrderIcon";
import OrderItemIcon from "../../assets/images/vectors/SideBarIcons/OrderItemIcon";
import LicenseIcon from "../../assets/images/vectors/SideBarIcons/LicenseIcon";
import LicenseOpIcon from "../../assets/images/vectors/SideBarIcons/LicenseOpIcon";
import AccountIcon from "../../assets/images/vectors/SideBarIcons/AccountIcon";
import DealerIcon from "../../assets/images/vectors/SideBarIcons/DealerIcon";
import OemIcon from "../../assets/images/vectors/SideBarIcons/OemIcon";
import OemInfoIcon from "../../assets/images/vectors/SideBarIcons/OemInfoIcon";
import PaymentIcon from "../../assets/images/vectors/SideBarIcons/PaymentIcon";
import CustomerIcon from "../../assets/images/vectors/SideBarIcons/CustomerIcon";
import { allProtectedRouteList } from "../constants/protectedRoute";
import { SipIcon } from "../../assets/images/vectors/SideBarIcons/SipIcon";
import PSIcon from "../../assets/images/vectors/SideBarIcons/PSIcon";
import { FaAddressCard, FaIdCardClip, FaUserTag } from "react-icons/fa6";
import { FaGlobe, FaIdCard, FaIdCardAlt } from "react-icons/fa";
import { RiAlignItemBottomFill } from "react-icons/ri";
import { getEnageUser } from "../hooks/getUserRole";

//SideBar items for System Admin & System Manager role
const systemAdminSiderbarItems = [
  {
    label: "Site",
    key: "/site",
    icon: <FaUserTag style={{ fontSize: "20px" }} />,
  },
  // {
  //   label: "Site",
  //   key: "/site",
  //   icon: <FaGlobe style={{ fontSize: "20px" }} />,
  // },
  {
    label: "Device",
    key: "/device",
    icon: <DeviceIcon />,
  },
  {
    label: "Device Log",
    key: "/devicelog",
    icon: <DeviceLogIcon />,
  },
  {
    label: "Order",
    key: "/order",
    icon: <OrderIcon />,
  },
  // {
  //   label: "Order Item",
  //   key: "/orderitemlist",
  //   icon: <OrderItemIcon />,
  // },
  {
    label: "Invoice",
    key: "/invoice",
    icon: <PaymentIcon />,
  },

  // {
  //   label: "License Option",
  //   key: "/licenseoptionlist",
  //   icon: <LicenseOpIcon />,
  // },
  {
    label: "Account",
    key: "/account",
    icon: <AccountIcon />,
  },
  {
    label: "Customer",
    key: "/customer",
    icon: <CustomerIcon />,
  },
  {
    label: "Dealer",
    key: "/dealer",
    icon: <DealerIcon />,
  },
  {
    label: "OEM",
    key: "/oem",
    icon: <OemIcon />,
  },
  {
    label: "Production",
    key: "/production",
    icon: <RiAlignItemBottomFill style={{ fontSize: "18px" }} />,
  },
  {
    label: "Hardware",
    key: "/hardware",
    icon: <RiAlignItemBottomFill style={{ fontSize: "18px" }} />,
  },
  {
    label: "License",
    key: "/license",
    icon: <LicenseIcon />,
  },
  {
    label: "License Code",
    key: "/licensecode",
    icon: <FaAddressCard style={{ fontSize: "16px" }} />,
  },
  {
    label: "OEM Info",
    key: "/oeminfo",
    icon: <OemInfoIcon />,
  },
  {
    key: "/proxyserver",
    icon: <PSIcon />,
    label: "Proxy Server",
  },
  {
    label: "SIP",
    key: "/sip",
    icon: <SipIcon />,
  },

  //   {
  //     label: "Users",
  //     key: "/users",
  //     icon: <TeamOutlined />,
  //     children: [
  //       {
  //         label: "Employees",
  //         key: "/employee",
  //         icon: <UserOutlined />,
  //       },
  //     ],
  //   },
];

//SideBar items for System User role
const systemUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device"].includes(item?.label),
);
//SideBar items for OEM Admin & OEM Manager role
const oemAdminSidebarItems = systemAdminSiderbarItems?.filter(
  (item) =>
    ![
      "Hardware",
      "License",
      "License Code",
      "OEM",
      "Production",
      "OEM Info",
      "Proxy Server",
      "SIP",
      "Device Log",
      "Order",
      "Invoice",
    ].includes(item?.label),
);
//SideBar items for OEM User role
const oemUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device"]
    // "Device Log", "Invoice"]
    .includes(item?.label),
);
//SideBar items for Dealer Admin & Dealer Manager role
const dealerAdminSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  [
    "Site",
    "Device",
    // "Device Log",
    // "Order",
    // "Invoice",
    "Account",
    "Customer",
  ].includes(item?.label),
);
//SideBar items for Dealer User role
const dealerUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Device"]
    // "Device Log", "Invoice"].
    .includes(item?.label),
);
//SideBar items for Customer Admin & Customer Manager role
const customerAdminSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site", "Account"].includes(item?.label),
);
//SideBar items for Customer User role
const customerUserSidebarItems = systemAdminSiderbarItems?.filter((item) =>
  ["Site"].includes(item?.label),
);

//Select Sidebar based on role
export const roleSidebarMenu = {
  1: systemAdminSiderbarItems,
  2: systemAdminSiderbarItems,
  3: systemUserSidebarItems,
  4: oemAdminSidebarItems,
  5: oemAdminSidebarItems,
  6: oemUserSidebarItems,
  7: dealerAdminSidebarItems,
  8: dealerAdminSidebarItems,
  9: dealerUserSidebarItems,
  10: customerAdminSidebarItems,
  11: customerAdminSidebarItems,
  12: customerUserSidebarItems,
};
export const getUserRoles = (userData) => {
  const role = userData?.role_value;

  return {
    isSystemUser: role < 4,
    isCustomerUser: [10, 11, 12].includes(role),
    isDealerUser: [7, 8, 9].includes(role),
    isOemUser: [4, 5, 6].includes(role),
  };
};

export const PrivateRoute = ({ children }) => {
  // const user = useAuth();
  const user = JSON.parse(sessionStorage.getItem("userData"));
  const engageUserData = getEnageUser();
  // console.log("user", user);
  const { pathname } = useLocation();

  // check current route is permitted or not
  const isPermittedRoute = allProtectedRouteList[user?.role_value]?.some(
    (item) =>
      item?.includes("engagesite")
        ? engageUserData?.username &&
          engageUserData?.password &&
          pathname?.replace(/^\/|\/[^\/]*$/g, "").replace(/\//g, "") ===
            item.replaceAll(/[\/\d]+/g, "")
        : pathname?.replaceAll(/[\/\d]+/g, "") ===
          item?.replaceAll(/[\/\d]+/g, ""),
  );

  return user && isPermittedRoute ? (
    <SideBar
      items={roleSidebarMenu[user?.role_value]?.filter(
        (item) =>
          ![
            "/hardware",
            "/license",
            "/licensecode",
            "/oeminfo",
            "/proxyserver",
            "/sip",
          ].includes(item.key),
      )}
    >
      {children}{" "}
    </SideBar>
  ) : (
    <Navigate to={"/"} />
  );
};
